module.exports = __webpack_public_path__ + "assets/images/logo_icron_2.0_bianco.png";